import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { TAREFAS_CONFIG_DESIGN as D } from './TarefasConfig.design';
import WorkflowsTab from './WorkflowsTab';
import { actionListaWorkflows } from 'src/actions/tarefas/actionTarefasConfig';

export default function TarefasConfigComponent() {
  const { user } = useAuth();
  const [listaWorkflows, setListaWorkflows] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);

  async function buscarWorkflows() {
    try {
      const response = await actionListaWorkflows(`?cliente_id=${user.clienteId}`);
      setListaWorkflows(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    buscarWorkflows();
  }, []);

  return (
    <div className={D.root} style={{ fontFamily: D.fontStack }}>
      <div className={D.stickyHeader}>
        <div className={D.container}>
          <div className={D.topbar}>
            <div className={D.topbarIdentity}>
              <div className="min-w-0">
                <h1 className={D.title}>Tarefas</h1>
                <p className={D.subtitle}>
                  Defina os fluxos e estágios que a equipe usa no dia a dia.
                </p>
              </div>
            </div>
            <div className={D.topbarActions}>
              <button type="button" onClick={() => setOpenCreate(true)} className={D.primaryButton}>
                Criar workflow
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`${D.container} pt-6 ${D.pageBody}`}>
        <WorkflowsTab
          listaWorkflows={listaWorkflows}
          onRefresh={buscarWorkflows}
          clienteId={user.clienteId}
          openCreate={openCreate}
          onOpenCreateHandled={() => setOpenCreate(false)}
        />
      </div>
    </div>
  );
}
